import React from 'react'
import ArtistCaseStudiesContainer from '../artist-case-studies-container'
import './artist.css'

const Artist = ({ setElementScroll, onSaveScroll, onSetScroll, setSmoothScroll, pageName, match, st }) => {

  const active = (match && match.isExact)
  const id = active ? match.params.artistId : null

  return (
    <div className="artist">
      <ArtistCaseStudiesContainer
        setElementScroll={setElementScroll}
        onSaveScroll={onSaveScroll}
        onSetScroll={onSetScroll}
        setSmoothScroll={setSmoothScroll}
        st={st}
        pageName={pageName}
        match={match}
        active={active}
        id={id} />
    </div>
  )
}

export default Artist



// WEBPACK FOOTER //
// ./src/components/artist-page/artist.js